var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section text-left margin-top-0" }, [
    _c("h3", { staticClass: "sr-only" }, [_vm._v("Features")]),
    _vm._v(" "),
    _c(
      "ul",
      {
        staticClass: "fa-ul",
        staticStyle: { "--list-margin-top": "var(--spacing-sm)" },
      },
      [
        (_vm.plan || _vm.subscription) && _vm.planSeats > 0
          ? _c(
              "li",
              { staticClass: "margin-bottom-sm padding-left-sm" },
              [
                _c(
                  "span",
                  { staticClass: "fa-li" },
                  [
                    _c("font-awesome-icon", {
                      class: `${_vm.context.seats.iconColor}`,
                      attrs: { icon: _vm.context.seats.icon, size: "lg" },
                    }),
                  ],
                  1
                ),
                _vm._v("\n      " + _vm._s(_vm.planSeats) + "\n      "),
                _c(
                  "site-link",
                  {
                    class: `link link-underline-dark color-inherit hover-${_vm.context.seats.hoverColor}`,
                    attrs: {
                      to: {
                        name: "support",
                        hash: "#who-needs-a-seat-on-my-pro-license",
                      },
                      "aria-label":
                        "Seats are required for all creators or editors using a Font Awesome Pro License. View more details.",
                      "data-balloon-pos": "up",
                      "data-balloon-length": "large",
                    },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.$posthog.capture("support_link_click", {
                          context: "plan_card",
                          location: "seats",
                        })
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.pluralize("Seat", _vm.planSeats)) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(
                  "\n\n      " +
                    _vm._s(
                      _vm.context.seats.extraSeatCostFormatted ? "+" : ""
                    ) +
                    "\n      "
                ),
                _vm.context.seats.extraSeatUpgradeInterval === 1 &&
                _vm.context.seats.extraSeatCostFormatted
                  ? _c(
                      "site-link",
                      {
                        attrs: {
                          to: { name: "plans", hash: "#overages" },
                          "aria-label": `Extra seats may be purchased for an extra ${_vm.context.seats.extraSeatCostFormatted} per seat per year. View more details.`,
                          "data-balloon-pos": "up",
                          "data-balloon-length": "large",
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.context.seats.extraSeatCostFormatted) +
                            " per extra seat\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.context.seats.extraSeatUpgradeInterval > 1 &&
                _vm.context.seats.extraSeatCostFormatted
                  ? _c(
                      "site-link",
                      {
                        attrs: {
                          to: { name: "plans", hash: "#overages" },
                          "aria-label": `Extra seats may be purchased for an extra ${_vm.context.seats.extraSeatCostFormatted} per ${_vm.context.seats.extraSeatUpgradeInterval} seats per year. View more details.`,
                          "data-balloon-pos": "up",
                          "data-balloon-length": "large",
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.context.seats.extraSeatCostFormatted) +
                            " / " +
                            _vm._s(_vm.context.seats.extraSeatUpgradeInterval) +
                            " seats\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.subscription && _vm.determinations.isBacker
          ? _c("li", { staticClass: "margin-bottom-sm padding-left-sm" }, [
              _c(
                "span",
                { staticClass: "fa-li" },
                [
                  _c("font-awesome-icon", {
                    class: `${_vm.context.lifetime5.iconColor}`,
                    attrs: { icon: _vm.context.lifetime5.icon, size: "lg" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  attrs: {
                    "aria-label":
                      "All the icons in Version 5 are yours to download and use in your projects forever!",
                    "data-balloon-pos": "up",
                    "data-balloon-length": "large",
                  },
                },
                [_vm._v("\n        Lifetime Version 5 Download\n      ")]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "margin-bottom-sm padding-left-sm" },
          [
            _c(
              "span",
              { staticClass: "fa-li" },
              [
                _c("font-awesome-icon", {
                  class: `${_vm.context.icons.iconColor}`,
                  attrs: { icon: _vm.context.icons.icon, size: "lg" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.subscription || _vm.determinations.active
              ? [
                  _vm._v(
                    "\n        " + _vm._s(_vm.context.icons.label) + "\n      "
                  ),
                ]
              : [_vm._v("Thousands of Icons")],
          ],
          2
        ),
        _vm._v(" "),
        _vm.context.icons.hasProPlus
          ? _c("li", { staticClass: "margin-bottom-sm padding-left-sm" }, [
              _c(
                "span",
                { staticClass: "fa-li" },
                [
                  _c("font-awesome-icon", {
                    class: `${_vm.context.icons.iconColor}`,
                    attrs: { icon: _vm.context.proPlus.icon, size: "lg" },
                  }),
                ],
                1
              ),
              _vm._v("\n      Includes Pro+ Icons\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "margin-bottom-sm padding-left-sm" },
          [
            _c(
              "span",
              { staticClass: "fa-li" },
              [
                _c("font-awesome-icon", {
                  class: `${_vm.context.uploads.iconColor}`,
                  attrs: { icon: _vm.context.uploads.icon, size: "lg" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.numberOfCustomIcons === -1
              ? [_vm._v("Unlimited " + _vm._s(_vm.context.uploads.label))]
              : (!_vm.plan && _vm.determinations.ended) ||
                _vm.determinations.isFree ||
                (_vm.determinations.isBacker && !_vm.determinations.active)
              ? _c("span", { class: _vm.featureStylingUnavailable }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.numberOfCustomIcons) +
                      " " +
                      _vm._s(_vm.context.uploads.label) +
                      "\n      "
                  ),
                ])
              : [
                  _vm._v(
                    _vm._s(_vm.numberOfCustomIcons) +
                      " " +
                      _vm._s(_vm.context.uploads.label)
                  ),
                ],
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "margin-bottom-sm padding-left-sm" },
          [
            _c(
              "span",
              { staticClass: "fa-li" },
              [
                _c("font-awesome-icon", {
                  class: `${_vm.context.kits.iconColor}`,
                  attrs: { icon: _vm.context.kits.icon, size: "lg" },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.numberOfKits === -1
              ? [_vm._v("Unlimited " + _vm._s(_vm.kitsLabel))]
              : (!_vm.plan && _vm.determinations.ended) ||
                (_vm.determinations.isBacker && !_vm.determinations.active)
              ? _c("span", { class: _vm.featureStylingUnavailable }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.numberOfKits) +
                      " " +
                      _vm._s(_vm.kitsLabel) +
                      "\n      "
                  ),
                ])
              : [
                  _vm._v(
                    _vm._s(_vm.numberOfKits) + " " + _vm._s(_vm.kitsLabel)
                  ),
                ],
          ],
          2
        ),
        _vm._v(" "),
        _c("li", { staticClass: "margin-bottom-sm padding-left-sm" }, [
          _c(
            "span",
            { staticClass: "fa-li" },
            [
              _c("font-awesome-icon", {
                class: `${_vm.context.pageviews.iconColor}`,
                attrs: { icon: _vm.context.pageviews.icon, size: "lg" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              attrs: {
                "aria-label":
                  "Each time one of your pages with a Font Awesome Kit is viewed, a pageview is counted. Pageviews are counted on a monthly basis.",
                "data-balloon-pos": "up",
                "data-balloon-length": "large",
              },
            },
            [
              (!_vm.plan && _vm.determinations.ended) ||
              (_vm.determinations.isBacker && !_vm.determinations.active)
                ? _c("span", { class: _vm.featureStylingUnavailable }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.context.pageviews.label) +
                        "\n        "
                    ),
                  ])
                : [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.context.pageviews.label) +
                        "\n        "
                    ),
                  ],
            ],
            2
          ),
        ]),
        _vm._v(" "),
        !_vm.isProLite
          ? _c("li", { staticClass: "padding-left-sm" }, [
              _c(
                "span",
                { staticClass: "fa-li" },
                [
                  _c("font-awesome-icon", {
                    class: `${_vm.context.bandwidth.iconColor}`,
                    attrs: { icon: _vm.context.bandwidth.icon, size: "lg" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  attrs: {
                    "aria-label":
                      "Install, manage, and use Font Awesome Pro via a package in npm, yarn, Python, and Ruby. Package bandwidth is counted on a monthly basis.",
                    "data-balloon-pos": "up",
                    "data-balloon-length": "large",
                  },
                },
                [
                  (!_vm.plan && _vm.determinations.ended) ||
                  _vm.determinations.isFree ||
                  (_vm.determinations.isBacker && !_vm.determinations.active)
                    ? _c("span", { class: _vm.featureStylingUnavailable }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.context.bandwidth.label) +
                            "\n        "
                        ),
                      ])
                    : [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.context.bandwidth.label) +
                            "\n        "
                        ),
                      ],
                ],
                2
              ),
            ])
          : _vm._e(),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }